import React, { useState } from 'react';
import { Button, Typography, Dialog, DialogTitle } from '@material-ui/core';
import Spacing from '../portico/spacing/spacing';
import ChatBubbleIcon from '@material-ui/icons/ChatBubble';
import CancelIcon from '@material-ui/icons/Cancel';
import useSupportStyles from './support.styles';
import CONSTANTS from '../../utils/constants';
import STATIC_TEXT from '../../content/common.json';

  
const Support: React.FC = (): JSX.Element => {
  const classes = useSupportStyles();

  const [supportDialog, setSupportDialog] = useState(false);

  const openSupportDialog = () => {
    setSupportDialog(true);
  }

  const closeSupportDialog = () => setSupportDialog(false);

  return (
    <>
      <Button
        disableRipple
        onClick={openSupportDialog}
        data-testid="app-support"
        data-cy="support-btn"
        color="primary"
        variant="text"
        className={classes.button}
      >
        <ChatBubbleIcon fontSize="medium" className={classes.icon} />
        <span>{STATIC_TEXT.supportDialog.title}</span>
      </Button>
      <Dialog
          open={supportDialog}
          onClose={closeSupportDialog}
          hideBackdrop={true}
          disableBackdropClick={true}
          PaperProps={{classes: { root: classes.leftAlignment}}}
          scroll="paper"
        >
          <div className={classes.supportDialog}>
          <DialogTitle className={classes.supportDialogTitle} disableTypography={true}>
          <span>{STATIC_TEXT.supportDialog.title}</span>          
          <CancelIcon data-testid="app-close-support" fontSize="medium" className={classes.titleIcon} onClick={closeSupportDialog}/>
          </DialogTitle>
          <Spacing variable="spacing-base-x4" />
          <Typography variant="h6" className={classes.bodyTitle}>{STATIC_TEXT.supportDialog.subtitle}</Typography>
          <Typography variant="body2"><label>{STATIC_TEXT.supportDialog.email}</label><a href={`mailto:${CONSTANTS.LENDX_SUPPORT_EMAIL}`} target="_blank" rel="noopener noreferrer">{CONSTANTS.LENDX_SUPPORT_EMAIL}</a></Typography>
          <Spacing variable="spacing-base-x4" />
          </div>
        </Dialog>
        
      
    </>
  );
};

export default Support;
